import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const footerLinks = [
  {
    title: '下载与安装',
    items: [
      { label: '官方下载渠道', path: '/article/official-download-channels' },
      { label: 'Android安装教程', path: '/article/android-download-install' },
      { label: 'iOS安装教程', path: '/article/ios-download-install' },
      { label: '安装问题排查', path: '/article/common-install-issues' },
    ],
  },
  {
    title: '使用帮助',
    items: [
      { label: '新用户注册', path: '/article/new-user-registration' },
      { label: '界面功能介绍', path: '/article/interface-features-guide' },
      { label: '离线下载使用', path: '/article/offline-download-feature' },
      { label: '个性化推荐', path: '/article/personalized-recommendation' },
    ],
  },
  {
    title: '常见问题',
    items: [
      { label: '账号问题解答', path: '/article/account-faq' },
      { label: '播放问题排查', path: '/article/playback-issues' },
      { label: '会员服务FAQ', path: '/article/membership-faq' },
      { label: '权限设置详解', path: '/article/app-permission-settings' },
    ],
  },
  {
    title: '关于我们',
    items: [
      { label: '品牌介绍', path: '/about' },
      { label: '用户口碑', path: '/about' },
      { label: '联系方式', path: '/about' },
      { label: '版本更新', path: '/article/version-3-2-0-update' },
    ],
  },
];

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-900">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-semibold text-background-200 mb-4 font-heading">
                  {group.title}
                </h4>
                <ul className="space-y-2.5">
                  {group.items.map((item) => (
                    <li key={item.label}>
                      <Link
                        to={item.path}
                        className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer"
                      >
                        {item.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="border-t border-background-700/50 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-2">
              <div className="w-7 h-7 rounded-md bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-background-50 text-sm"></i>
              </div>
              <span className="text-sm text-background-300 font-heading">
                {t('footer_brand')}
              </span>
            </div>

            <p className="text-sm text-background-500">
              &copy; {new Date().getFullYear()} {t('footer_brand')} {t('footer_rights')}
            </p>

            <div className="flex items-center gap-4">
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700/50 text-background-400 hover:text-background-100 hover:bg-background-600/50 transition-colors cursor-pointer"
                aria-label="微信"
                rel="nofollow"
              >
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700/50 text-background-400 hover:text-background-100 hover:bg-background-600/50 transition-colors cursor-pointer"
                aria-label="微博"
                rel="nofollow"
              >
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700/50 text-background-400 hover:text-background-100 hover:bg-background-600/50 transition-colors cursor-pointer"
                aria-label="抖音"
                rel="nofollow"
              >
                <i className="ri-tiktok-line text-sm"></i>
              </a>
              <a
                href="#"
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700/50 text-background-400 hover:text-background-100 hover:bg-background-600/50 transition-colors cursor-pointer"
                aria-label="B站"
                rel="nofollow"
              >
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}